<template>
	<div style="padding: 10px;min-width: 1400px;">
		<el-row :gutter="20">
			<el-col :span="6"> 
				<el-input clearable placeholder="请输入订单编号" v-model="searchInfo.orderNo">
					<template slot="prepend">订单编号</template>
				</el-input>
			</el-col>
			<el-col :span="6">
				<el-input clearable placeholder="请输入客户名称" v-model="searchInfo.customName">
					<template slot="prepend">客户名称</template>
				</el-input>
			</el-col>
			<el-col :span="6">
				<el-input clearable placeholder="请输入客户电话" v-model="searchInfo.customTel">
					<template slot="prepend">客户电话</template>
				</el-input>
			</el-col>
		</el-row>
		<el-row style="margin-top: 10px;" :gutter="20">
			<el-col :span="6">
				<el-input clearable placeholder="请输入配送人名称" v-model="searchInfo.senderName">
					<template slot="prepend">配送人名称</template>
				</el-input>
			</el-col>
			<el-col :span="6">
				<el-input clearable placeholder="请输入配送人电话" v-model="searchInfo.senderTel">
					<template slot="prepend">配送人电话</template>
				</el-input>
			</el-col>
			<el-col :span="6">
				<el-select clearable style="width: 100%;" v-model="searchInfo.orderStatus" filterable placeholder="请选择订单状态">
				    <el-option v-for="item in orderSateList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
				</el-select>
			</el-col>
		</el-row>
		<el-row style="margin-top: 10px;" :gutter="20">
			<el-col :span="6">
				<el-select clearable style="width: 100%;" v-model="searchInfo.stallID" filterable placeholder="请选择档口">
				    <el-option v-for="item in stallList" :key="item.stall_id" :label="item.stall_name" :value="item.stall_id"> </el-option>
				</el-select>
			</el-col>
			<el-col :span="7">
				<el-date-picker v-model="searchInfo.time" value-format="yyyy-MM-dd" type="daterange"
				      start-placeholder="开始时间"  end-placeholder="结束时间" >
				</el-date-picker>
			</el-col>
			<el-col :span="5"> 
				  <el-button type="primary" @click="searchOrders" icon="el-icon-search">搜索</el-button>
				  <el-button  icon="el-icon-refresh" @click="clearSearch">重置</el-button>
			</el-col>
		</el-row>
		<div style="margin-top: 10px;">
			<el-table :data="orderList"  style="width: 100%;" height="650">
			    <el-table-column fixed="left" prop="code" label="菜品" width="650" align="center">
					<template slot-scope="scope">
						<el-row style="background-color: #F2F2F2;font-size: 12px;">
							<el-col :span="9">
								订单号：<span style="">{{scope.row.orderno}}</span>
							</el-col>
							<el-col :span="9">
								下单时间：<span style="">{{scope.row.ordertime}}</span>
							</el-col>
							<el-col :span="6">
								买家：<span style="color: #409EFF;">{{scope.row.customname}}</span>
							</el-col>
						</el-row>
						<el-row style="margin-top: 10px;" v-for="(food) in scope.row.foods" :key="scope.row.orderno + food.id">
							<el-col :span="16" >
								<div style="width: 100px;float: left;">
									<el-image style="width: 80px; height: 80px;border-radius: 10px;" :src="food.pic"  fit="cover"></el-image>
								</div>
								<div style="float: left;text-align: left;">
									<p style="color: #409EFF;font-size: 12px;">{{food.name}}</p>
									<p style="font-size: 12px;">规格：{{food.spec}}</p>
								</div>
							</el-col>
							<el-col :span="4">
								<p>￥{{food.price}}</p>
							</el-col>
							<el-col :span="4">
								<p>x{{food.number}}</p>
							</el-col>
						</el-row>
					</template>
				</el-table-column>
			    <el-table-column prop="type" label="配送地址" width="120" align="center">
					<template slot-scope="scope">
						<p>{{scope.row.sendarea}}</p> 
						<p>{{scope.row.sendaddress}}</p>
					</template>
				</el-table-column>
			    <el-table-column prop="delivername" label="配送员"  width="120" align="center"></el-table-column>
			    <el-table-column prop="amount" label="应付款" align="center">
					<template slot-scope="scope">
						￥{{scope.row.amount}}
					</template>
				</el-table-column>
				<el-table-column prop="statename" label="订单状态" width="120" align="center"></el-table-column>
			    <el-table-column prop="paystatename" label="交易状态" align="center"></el-table-column>
				<el-table-column fixed="right" prop="op" label="操作" width="200" align="center">
					<template slot-scope="scope">
						<a @click="goOrderDetail(scope.$index, scope.row)" title="订单详情" style="display:inline-block;cursor:pointer;color: #409EFF;">
							<i class="el-icon-dish">订单详情</i>
						</a>
						<a @click="printOrder(scope.$index, scope.row)" title="补打餐条" style="display:inline-block;cursor:pointer;color: #409EFF;margin-left: 20px;">
							<i class="el-icon-printer">补打餐条</i>
						</a>
						<a @click="closeOrders(scope.$index, scope.row)" title="结束订单" style="display:inline-block;cursor:pointer;color: #409EFF;margin-left: 20px;">
							<i class="el-icon-close" v-show="scope.row.state != 'overed' && scope.row.state != 'cancel'">结束订单</i>
						</a>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div style="text-align: center;">
			<el-pagination background layout="total, prev, pager, next, sizes" :page-sizes="[10, 20, 50]" :current-page="param.page"
				:page-size="param.pagenum" :total="orderTotal" @size-change="handleSizeChange" @current-change="handleCurrentChange"> </el-pagination>
		</div>
		<el-dialog :destroy-on-close="false" title="订单详情" width="80%" :visible.sync="orderdetailShow">
			<OrderDetail :orderno="selectorderno"></OrderDetail>
		</el-dialog>
		<el-dialog @close="refrashData" :destroy-on-close="false" :title="closedetailTitle" width="40%" :visible.sync="ordercloseShow">
			<OrderClose @needRefrash="needRefrash_Close" :orderno="selectorderno"></OrderClose>
		</el-dialog>
	</div>
</template>

<script>
	import OrderDetail from './orderdetail.vue'
	import OrderClose from './orderclose.vue';
	import {nfsprefix , baseUrl } from '/static/baseUrl.js'
	import { queryOrderLists,reprintOrderPaper,queryStallLists } from '/static/apiUrl.js'
	export default {
		name : 'TodayOrders',
		data() {
			return {
				tableHeight : 'calc(100% - 180px)',
				orderdetailShow: false,
				ordercloseShow: false,
				closedetailTitle: "结束订单",
				searchInfo: {
					stallID : '',
					orderNo : '',
					customName : '',
					customTel : '',
					senderTel : '',
					senderName : '',
					orderStatus : '',
					stallName : '',
					orderTime_Beg : '',
					orderTime_End : '',
					time : ''
				},
				param : {
					page : 1,
					pagenum : 10,
				},
				selectorderno : '',
				orderTotal : 0,
				orderSateList : [
					{
						label : '所有',
						value : '',
					},
					{
						label : '待支付',
						value : 'notpay',
					},
					{
						label : '待出餐',
						value : 'notdining',
					},
					{
						label : '待配送',
						value : 'notsend',
					},
					{
						label : '配送中',
						value : 'sending',
					},
					{
						label : '待取餐',
						value : 'sended',
					},
					{
						label : '已取餐',
						value : 'pickuped',
					},
					{
						label : '已结束',
						value : 'overed',
					},
					{
						label : '已取消',
						value : 'cancel',
					},
				],
				orderList : [],
				stallList : [],
			}
		},
		mounted() {
			this.initData()
			this.searchOrders()
		},
		methods: {
			initData() {
				queryStallLists({
					state: "normal",
					offset: 0,
					limit: 100
				}).then(res => {
					console.log(res)
					if (0 == res.code) {
						this.stallList = res.data.data
					}
				})
			},
			handleSizeChange(val){
				console.log(val);
				this.param.pagenum = val;
				this.orderList = []
				this.queryOrders()
			},
			handleCurrentChange(val){
				console.log(val);
				this.param.page = val
				this.orderList = []
				this.queryOrders()
			},
			closeOrders(idx, row) {
				console.log(idx,row)
				this.closedetailTitle = "结束订单"
				this.selectorderno = row.orderno
				this.ordercloseShow = true
			},	
			clearSearch() {
				this.searchInfo.stallID = ''
				this.searchInfo.customName = ''
				this.searchInfo.orderNo = ''
				this.searchInfo.customTel = ''
				this.searchInfo.senderTel = ''
				this.searchInfo.senderName = ''
				this.searchInfo.orderStatus = ''
				this.searchInfo.stallName = ''
				this.searchInfo.orderTime_Beg = ''
				this.searchInfo.orderTime_End = ''
				this.searchInfo.time = ''
			},
			searchOrders(){
				this.param.page = 1
				this.orderList = []
				this.queryOrders()
				
			},
			queryOrders() {
				this.orderList = []
				queryOrderLists({
					stallID: this.searchInfo.stallID,
					orderNo: this.searchInfo.orderNo,
					customName: this.searchInfo.customName,
					customTel: this.searchInfo.customTel,
					senderTel: this.searchInfo.senderTel,
					senderName: this.searchInfo.senderName,
					orderStatus: this.searchInfo.orderStatus,
					stallName: this.searchInfo.stallName,
					orderTime_Beg: this.searchInfo.time ? this.searchInfo.time[0] + ' 00:00:00' : '',
					orderTime_End: this.searchInfo.time ? this.searchInfo.time[1] + ' 23:59:59': '',
					pageIndex: this.param.page,
					pageSize: this.param.pagenum
				}).then(res => {
					console.log(res)
					if(0 == res.code && res.data != null){
						this.orderTotal = res.data.total
						if(res.data.data){
							res.data.data.forEach((item) => {
								let od = {
									id: item.Stallsorders_Id,
									orderno : item.Stallsorders_Orderno ,
									ordertime : item.Stallsorders_Ordertime.replace('T',' ') ,
									customname : item.Stallsorders_Recipient,
									customid : item.Stallsorders_Customid,
									foods : [],
									sendarea : item.Stallsorders_Sendarea,
									sendaddress : item.Stallsorders_Sendaddress,
									delivername : item.Stallsorders_Deliverpersonname,
									deliverphone : '',
									amount : item.Stallsorders_Orderpayedamount,
									state : item.Stallsorders_State,
									statename : this.getOrderStateName(item.Stallsorders_State),
									paystate : item.Stallsorders_Paystate,
									paystatename : item.Stallsorders_Paystate == 'payed' ? '已支付' : '未支付',
								}
								item.Orderfoods.forEach((f) => {
									let picurl = ""
									if(f.Foodspicture != undefined && f.Foodspicture != null && f.Foodspicture.length > 0){
										picurl = baseUrl +nfsprefix+ f.Foodspicture[0].Foodspicture_Fileurl
									}
									let fd = {
										id : f.Orderfoods_Id,
										name : f.Orderfoods_Name,
										pic : picurl,
										spec : f.Orderfoods_Spec,
										price : f.Orderfoods_Platformoffprice,
										number : f.Orderfoods_Unmber
									}
									od.foods.push(fd)
								})
								this.orderList.push(od)
							})
						}
					}
				})
			},
			getOrderStateName(st){
				/* notpay-待支付 notdining-待出餐 notsend-待配送 sending-配送中 
				sended-待取餐（配送完成） pickuped-已取餐  overed-已结束 cancel-已取消 */
				if(st == 'notpay'){
					return '待支付'
				}else if(st == 'notdining'){
					return '待出餐'
				}else if(st == 'notsend'){
					return '待配送'
				}else if(st == 'sending'){
					return '配送中'
				}else if(st == 'sended'){
					return '待取餐'
				}else if(st == 'pickuped'){
					return '待评论'
				}else if(st == 'overed'){
					return '已结束'
				}else if(st == 'cancel'){
					return '已取消'
				}
				return ''
			},
			goOrderDetail(idx,row){
				console.log(idx,row)
				this.selectorderno = row.orderno
				this.orderdetailShow = true
			},
			printOrder(idx,row){
				console.log(idx,row)
				this.$prompt('请输入您的密码', '提示', {
					inputType: 'password',
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					//inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
					//inputErrorMessage: '邮箱格式不正确'
				}).then(({ value }) => {
					reprintOrderPaper({
						userId : '',
						orderid : row.id,
						pwd : this.$md5(value)
					}).then(res => {
						if(0 == res.code){
							this.$message({
								type: 'success',
								message: '打印成功'
							});
						}else{
							this.$message({
								type: 'error',
								message: res.msg
							});
						}
					})
					
				}).catch(() => { });
				
			},
			needRefrash_Close(val, isshow) {
				console.log(val, isshow)
				this.editok = val
				this.ordercloseShow = isshow
			},			
			refrashData() {				
				if (this.editok) {					
					this.queryOrders()
				}
			}
		},
		components: {
			OrderDetail,
			OrderClose,
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>